import { useState, useEffect } from 'react';
import moment from 'moment';
import { formatTime } from 'shared-utils';
import { useLocation, useNavigate } from 'react-router-dom';

interface TimerProps {
	// time?: Date;
	time: number | Date;
}

const Timer = ({ time }: TimerProps) => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const [countdown, setCountdown] = useState(moment(time).diff(moment(), 'second'));
	useEffect(() => {
		const timer = setInterval(() => {
			if (countdown > 0) {
				setCountdown(moment(time).diff(moment(), 'second'));
			}
		}, 1000);

		return () => {
			clearInterval(timer);
		};
	}, [countdown, time]);

	useEffect(() => {
		if (countdown <= 0) {
			setCountdown(0);
			// if (isRenderedered && !pathname.startsWith('/dashboard')) navigate('/dashboard');
		}
	}, [countdown, navigate]);

	return (
		<>
			<div className="relative flex w-max gap-4 rounded-[8px] bg-[#192532] px-3 py-[6px] text-lg font-medium text-[#FC0]">
				<div className="flex flex-col items-center justify-center">
					<div className="min-w-[24px] text-center">{formatTime(countdown).formattedHours}</div>

					<div className="text-[8px] font-normal leading-[8px] text-white">hours</div>
				</div>
				<div className="flex flex-col items-center justify-center">
					<div className="w-[24px] text-center">{formatTime(countdown).formattedMinutes}</div>

					<div className="text-[8px] font-normal leading-[8px] text-white">mins</div>
				</div>
				<div className="flex flex-col items-center justify-center">
					<div className="w-[24px] text-center">{formatTime(countdown).formattedSeconds}</div>

					<div className="text-[8px] font-normal leading-[8px] text-white">sec</div>
				</div>

				<div className="absolute right-[82px] w-max text-lg font-medium text-white">:</div>
				<div className="absolute right-[42px] w-max text-lg font-medium text-white">:</div>
			</div>
		</>
	);
};

export default Timer;
